import { ContentType } from '@medplum/core';
import type { MedplumClient } from '@medplum/core';
import type { Identifier } from '@medplum/fhirtypes';

import type { ManualVobFormInput } from '../schemas/manual-vob.schema';

const ELIGIBILITY_MANUAL_ENTRY_BOT: Identifier = {
  system: 'https://unify.health/bots',
  value: 'eligibility-manual-entry',
};

function getManualEntryBotTarget(): string | Identifier {
  const id = import.meta.env.VITE_MEDPLUM_ELIGIBILITY_MANUAL_ENTRY_BOT_ID?.trim();
  if (id) return id;
  return ELIGIBILITY_MANUAL_ENTRY_BOT;
}

export interface EligibilityManualEntryResult {
  ok: boolean;
  reason?: string;
  requestId?: string;
  responseId?: string;
}

export function toStaffManualVobPayload(
  values: ManualVobFormInput,
  options?: { serviceDate?: string },
): ManualVobFormInput {
  return {
    ...values,
    serviceDate: values.serviceDate ?? options?.serviceDate,
  };
}

export async function submitManualVobEntry(
  medplum: MedplumClient,
  input: ManualVobFormInput,
): Promise<EligibilityManualEntryResult> {
  return medplum.executeBot(
    getManualEntryBotTarget(),
    toStaffManualVobPayload(input),
    ContentType.JSON,
  ) as Promise<EligibilityManualEntryResult>;
}
